module.exports = __webpack_public_path__ + "images/6a7d0c1d420daa25016b7c2131dd8218.svg";